module.exports = {"gameover":{"src":"common/grid/item/mak01_gameover.png","type":"valve"},"halmet1":{"src":"common/grid/animate/origin.json","type":"hero"},"halmet2":{"src":"common/grid/animate/hiphop.json","type":"hero"},"halmet3":{"src":"common/grid/animate/ballerina.json","type":"hero"},"halmet4":{"src":"common/grid/animate/painter.json","type":"hero"},"halmet5":{"src":"common/grid/animate/teacher.json","type":"hero"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/util/R_DefaultResource.json
// module id = owon
// module chunks = 4